export const categoryData = [
  // { id: "currency", name: "Валюта" },
  { id: "discount", name: "Тип цін" },
];
